import { Component, OnInit, ChangeDetectorRef, Input } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import * as jsPDF from 'jspdf';
import * as _html2canvas from "html2canvas";
const html2canvas: any = _html2canvas;
import { ActivatedRoute, Params, Router } from '@angular/router';
import { UserService } from '../services/user.service';

declare global {
  interface Window {
    onePageCanvas?: any;
  }
}

@Component({
  selector: 'app-view-test-results',
  templateUrl: './view-test-results.component.html',
  styleUrls: ['./view-test-results.component.scss']
})
export class ViewTestResultsComponent implements OnInit {

  @Input() userObject: any;
  @Input() lessonObject: any;
  @Input() listOfAttempts: any;

  public quizReviewObject;
  public selectedAttemp: any;
  public modalRef: NgbModalRef;
  public userId: any = null;
  public downloading: boolean = false;
  public lessonId: any = null;

  constructor(
    private userService: UserService, 
    private router: Router,
    private cd: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.userId = params['user-id'];
      this.lessonId = params['lession-id'];
    })
    this.getQuizReview();
  }

  private getQuizReview() {
    this.userService.getQuizReviewFromMail(this.userId, this.lessonId).subscribe(
      (res) => {
        this.quizReviewObject = res;
        this.cd.markForCheck();
        this.cd.detectChanges();
      },
      (err) => {
        if (err.status == 401) {
          this.modalRef.close();
        }
      });
  }

  closeModal() {
    this.router.navigate(['/']);
  }

  downloadResult() {
    this.downloading = true;
    setTimeout(() => {
      this.startDownload()
    }, 1000)
  }

  startDownload() {
    let divcontent = document.getElementById('clickbind');

    html2canvas(divcontent, { useCORS: true, allowTaint: true }).then(canvas => {
      let pdf = new jsPDF('p', 'pt', [canvas.width, canvas.height]);
      let imgData = canvas.toDataURL("image/jpeg", 1.0);
      pdf.addImage(imgData, 0, 0, canvas.width, canvas.height);
      let pdfName = Math.floor(Math.random() * 9999999999) + '.pdf';
      pdf.save(pdfName);
      this.downloading = false;
    });

  }

}



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/view-test-results/view-test-results.component.ts